<template>
  <div class="container">
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入操作内容或操作人员"
        v-model.trim="condition"
        class="input-item mr10"
      ></el-input>
      <el-date-picker
        class="input-item mr10"
        size="small"
        v-model="startTime"
        type="date"
        placeholder="开始时间"
        :disabledDate="startDisabledDate"
      >
      </el-date-picker>
      <el-date-picker
        class="input-item mr10"
        size="small"
        v-model="endTime"
        type="date"
        placeholder="结束时间"
        :disabledDate="endDisabledDate"
      >
      </el-date-picker>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="getData(1)"
        size="small"
        >搜索</el-button
      >
    </div>
    <el-table
      :data="data.records"
      border
      class="table"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column
        prop="content"
        header-align="center"
        show-overflow-tooltip
        label="操作内容"
      ></el-table-column>
      <el-table-column align="center" width="150" label="操作时间">
        <template #default="scope">
          {{ $utils.formatDate(scope.row.createTime, "yyyy-MM-dd hh:mm") }}
        </template>
      </el-table-column>
      <el-table-column
        prop="managerName"
        width="150"
        label="操作人员"
        align="center"
      >
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { reactive, ref, toRefs } from "vue";
import { ElMessage } from "element-plus";
import api from "./../../../api/index.js";
import NProgress from "nprogress";

export default {
  setup() {
    const condition = ref("");
    const startTime = ref("");
    const endTime = ref("");
    let data = reactive({ data: {} });
    var dayjs = require("dayjs");

    const startDisabledDate = (time) => {
      if (!endTime.value) return false;
      time = new Date(time);
      var date = new Date(endTime.value);
      return time.getTime() > date.getTime();
    };

    const endDisabledDate = (time) => {
      if (!startTime.value) return false;
      time = new Date(time);
      var date = new Date(startTime.value);
      return time.getTime() < date.getTime();
    };

    const getData = async (page = 1) => {
      if (condition.value.length > 30) {
        ElMessage.warning("搜索内容最多输入30个字");
        return;
      }
      let start = startTime.value
        ? dayjs(startTime.value).format("YYYY-MM-DD")
        : "";
      let end = endTime.value ? dayjs(endTime.value).format("YYYY-MM-DD") : "";
      const params = {
        condition: condition.value,
        startTime: start || "",
        endTime: end || "",
        currentPage: page,
        pageSize: 20,
      };
      try {
        NProgress.start();
        const res = await api.log.getData(params);
        NProgress.done();
        if (res.code === 10200) {
          data.data = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      } catch (error) {
        NProgress.done();
      }
    };
    getData();

    return {
      condition,
      startTime,
      endTime,
      ...toRefs(data),
      getData,
      startDisabledDate,
      endDisabledDate,
    };
  },
};
</script>

<style lang="scss" scoped>
.handle-box {
  margin-bottom: 20px;

  .input-item {
    width: 180px;
  }
}
</style>